import { useState } from 'react'
import {
  View,
  Text,
  KeyboardAvoidingView,
  TouchableOpacity,
  Platform,
  Alert,
  ScrollView,
  TextInput,
  ActivityIndicator,
  StyleSheet
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import {
  Ionicons,
  AntDesign,
} from '@expo/vector-icons'
import Card from '../../../components/shared/card/Card'
import { Formik } from 'formik'
import { usepaycheckStore } from '../../../stores/paycheck'
import * as yup from 'yup'
import { AlertWeb } from '../../../utils'
import Select from '../../../components/shared/form/Select'
import ScanOrUploadDeposit from '../../../components/board/ScanOrUploadDeposit'
import * as ImagePicker from 'expo-image-picker'
import * as DocumentPicker from 'expo-document-picker'
import {
  getFormData
} from '../../../helpers/onboardingHelper'
import { useInitializeStore } from '../../../stores/initialize'
import CustomButton from '../../../components/shared/button/Button'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import ModalPopup from '../../../components/shared/modal/ModalPopup'

const Editdirectdeposit = ({ navigation, route }: any) => {
  const { item, index, fkey, obkey, mode } = route.params

  console.log(fkey, obkey)

  const paycheckstore = usepaycheckStore()

  const [imgData, setImgData] = useState<any>(null)
  const [routingError, setRoutingError] = useState<string | null>(null)
  const [isFetchingBank, setIsFetchingBank] = useState(false)
  const [bankModalVisible, setBankModalVisible] = useState(false)
  const intialValues = {
    accountNumber: item.accountNumber,
    routingNumber: item.routingNumber,
    amount: item.amount || '',
    bank: item.financialInstitution || ''
  }
  const [selectedOption, setSelectedOption] = useState<any>('Checking Account')
  const handleSelect = (selectedOption: string | null) => {
    setSelectedOption(selectedOption)
  }
  const [uploadVisible, setUploadVisible] = useState(false)
  const [show, setShow] = useState(false)
  const initializestore = useInitializeStore()
  const handlePickImage = async () => {
    const options = {
      allowsEditing: false,
      quality: 1
    }
    const result = await ImagePicker.launchImageLibraryAsync(options)

    if (!result.canceled) {
      try {
        const formData = await getFormData(result.assets[0].uri, 'checkimage', [
          '.png',
          '.jpg',
          '.jpeg'
        ])
        setImgData(formData)
        setShow(false)
      } catch (error: any) {
        if (Platform.OS === 'web') {
          AlertWeb('Image not supported', error.message)
        } else {
          Alert.alert('Image not supported', error.message)
        }
      } finally {
        setUploadVisible(false)
      }
    }
  }
  const handlePickDocument = async () => {
    const options = {}
    const result = await DocumentPicker.getDocumentAsync(options)
    if (!result.canceled) {
      try {
        const formData = await getFormData(result.assets[0].uri, 'checkimage', [
          '.png',
          '.jpg',
          '.jpeg'
        ])
        setImgData(formData)
        setShow(false)
      } catch (error: any) {
        if (Platform.OS === 'web') {
          AlertWeb('File not supported', error.message)
        } else {
          Alert.alert('File not supported', error.message)
        }
      } finally {
        setUploadVisible(false)
      }
    }
  }

  const w4schema = (index: any) => {
    const baseSchema = {
      accountNumber: yup
        .string()
        .matches(/^[0-9]+$/, 'Please enter only numeric values')
        .required('Account Number is a required field'),
      routingNumber: yup
        .string()
        .matches(/^[0-9]{9}$/, "Routing Number must be exactly 9 digits")
        .required("Routing Number is a required field"),
      bank: yup.string().required('Financial Institution is a required field'),
      amount: yup
        .string()
        .matches(/^[0-9]+$/, 'Please enter only numeric values')
    }


    if (index && index > 0) {
      baseSchema.amount = baseSchema.amount.required(
        'Amount is a required field'
      )
    }

    return yup.object(baseSchema)
  }
  const schema = w4schema(index)
  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{ flex: 1 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel='Update Direct Deposit'
            navScreen='UpdateDirectDeposit'
            title='Edit Direct Deposit Form'
            params={{
              essUserOnBoardingFormKey: fkey,
              essUserOnBoardingKey: obkey,
              mode
            }}
          />
        </View>
      </View>

      <View style={[globalStyles.containerOverlap, { flex: 1 }]}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {
            if (routingError) return
            const data: any = await paycheckstore.editDepositDetails(
              values.amount,
              initializestore.initializeData?.userkey,
              values.accountNumber,
              selectedOption,
              values.routingNumber,
              item.depositKey,
              imgData,
              values?.bank
            )
            if (data?.success) {
              navigation.navigate('UpdateDirectDeposit', {
                essUserOnBoardingFormKey: fkey,
                essUserOnBoardingKey: obkey,
                mode: mode
              })
              paycheckstore.getDepositDetails(
                initializestore.initializeData.userkey
              )
            }

          }}
        >
          {(props) => (
            <ScrollView>
              <Card>
                <>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Routing Number'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden', justifyContent: 'center' }}>
                      <TextInput
                        style={[
                          globalStyles.input,
                          globalStyles.inputLight,
                          globalStyles.inputReadOnly
                        ]}
                        value={props.values.routingNumber}
                        keyboardType="numeric"
                        maxLength={9}
                        onChangeText={async (text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.setFieldValue('routingNumber', text)
                            if (text.length === 9) {
                              setIsFetchingBank(true)
                              setRoutingError(null)
                              try {
                                const response = await paycheckstore.fetchBankNameByRoutingNumber(text)
                                let bankName = ''
                                if (response?.data?.bankDetailsList?.[0]?.bankName) {
                                  bankName = response.data.bankDetailsList[0].bankName
                                } else if (typeof response === 'string') {
                                  bankName = response
                                } else {
                                  bankName = response?.financialInstitution || response?.bankName || response?.bank || ''
                                }
                                if (bankName && bankName.trim() !== '') {
                                  props.setFieldValue('bank', bankName)
                                  setRoutingError(null)
                                } else {
                                  props.setFieldValue('bank', '')
                                  setRoutingError('Invalid routing number entered. Please check the number with your bank and try again. If you have verified accuracy and are still receiving this error please ask your admin to contact FMS Help Desk for assistance.')
                                }
                              } catch (error) {
                                props.setFieldValue('bank', '')
                                setRoutingError('Invalid routing number entered. Please check the number with your bank and try again. If you have verified accuracy and are still receiving this error please ask your admin to contact FMS Help Desk for assistance.')
                              } finally {
                                setIsFetchingBank(false)
                              }
                            } else {
                              props.setFieldValue('bank', '')
                              setRoutingError(null)
                            }
                          }
                        }}
                      />
                      {isFetchingBank && (
                        <ActivityIndicator
                          size="small"
                          color={colorPalette.primary}
                          style={{ position: 'absolute', right: 5 }}
                        />
                      )}
                      {(props.touched.routingNumber && props.errors.routingNumber) || routingError ? (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.routingNumber as string || routingError}
                        </Text>
                      ) : null}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Account Number'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[
                          globalStyles.input,
                          globalStyles.inputLight,
                          globalStyles.inputReadOnly
                        ]}
                        value={props.values.accountNumber}
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('accountNumber')(text)
                          }
                        }}
                        keyboardType="numeric"
                      />
                      {props.touched.accountNumber &&
                        props.errors.accountNumber && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.accountNumber as string}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary,
                        { marginTop: 10 }
                      ]}
                    >
                      Type of Account
                    </Text>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <Select
                        title="Select Account Type"
                        options={['Savings Account', 'Checking Account']}
                        selectedOption={selectedOption}
                        onSelect={handleSelect}
                        textColor="primary"
                      />
                    </View>
                  </View>

                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Financial Institution'}
                      </Text>
                    </View>
                    <TouchableOpacity
                      style={{ width: '28%', overflow: 'hidden' }}
                      onPress={() => {
                        setBankModalVisible(true)
                      }}
                      activeOpacity={0.7}
                    >
                      <TextInput
                        style={[
                          globalStyles.input,
                          globalStyles.inputLight,
                          globalStyles.inputReadOnly
                        ]}
                        value={props.values.bank}
                        editable={false}
                        pointerEvents="none"
                        onChangeText={(text) => {
                          props.handleChange('bank')(text)
                        }}
                      />
                      {props.touched.bank &&
                        props.errors.bank && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.bank as string}
                          </Text>
                        )}
                    </TouchableOpacity>
                  </View>
                  <ModalPopup
                    visible={bankModalVisible}
                    position="middle"
                    screen="dropdown"
                    flatBottom={false}
                  >
                    <View style={styles.modalHeader}>
                      <Text
                        style={[
                          globalStyles.text,
                          globalStyles.fs18,
                          globalStyles.fwBold,
                          globalStyles.blackTextColor
                        ]}
                      >
                        Financial Institution
                      </Text>
                      <TouchableOpacity
                        onPress={() => setBankModalVisible(false)}
                      >
                        <Ionicons
                          name="close-sharp"
                          size={24}
                          color={colorPalette.black}
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={styles.modalBody}>
                      <Text
                        style={[
                          globalStyles.text,
                          globalStyles.fs16,
                          globalStyles.fwSemiBold,
                          { paddingVertical: 15, paddingHorizontal: 10, textAlign: 'left' }
                        ]}
                      >
                        {props.values.bank || 'No financial institution found'}
                      </Text>
                      <View
                        style={{
                          alignItems: 'center',
                          marginTop: 10,
                          marginBottom: 5
                        }}
                      >
                        <View style={{ width: 100 }}>
                          <CustomButton
                            text="OK"
                            onPress={() => setBankModalVisible(false)}
                            color="primary"
                          />
                        </View>
                      </View>
                    </View>
                  </ModalPopup>
                  {index > 0 && (
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Amount'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[
                            globalStyles.input,
                            globalStyles.inputLight,
                            globalStyles.inputReadOnly
                          ]}
                          value={props.values.amount}
                          //onChangeText={props.handleChange('amount')}
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              // props.handleChange('extraWithholdingPerPay')(text)
                              props.handleChange('amount')(text)
                            }
                          }}
                          keyboardType="numeric"
                        />
                        {props.touched.amount && props.errors.amount && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.amount as string}
                          </Text>
                        )}
                      </View>
                    </View>
                  )}
                  <ScanOrUploadDeposit
                    title={`Scan or Upload check`}
                    visible={uploadVisible}
                    setVisible={setUploadVisible}
                    scanDocumentsAction={() => { }}
                    photoLibraryAction={handlePickImage}
                    importFilesAction={handlePickDocument}
                  />
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between'
                    }}
                  >
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary,
                        { marginTop: 10 }
                      ]}
                    >
                      Upload Check
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        setUploadVisible(!uploadVisible)
                      }}
                      style={[
                        globalStyles.flexOne,
                        globalStyles.hEndItems,
                        globalStyles.vEndItems,
                        { marginTop: 7 }
                      ]}
                    >
                      <AntDesign
                        name="upload"
                        size={24}
                        color={colorPalette.tertiary}
                      />
                    </TouchableOpacity>
                  </View>
                  {show && (
                    <Text style={{ color: 'red', textAlign: 'right' }}>
                      Please select a Image
                    </Text>
                  )}
                </>

                <View style={{ marginTop: 10, justifyContent: 'flex-end' }}>
                  {paycheckstore.loading ? (
                    <ActivityIndicator size="large" />
                  ) : (
                    <View style={{ flex: 1, justifyContent: 'flex-end' }}>
                      <View style={{ margin: 10 }}>
                        <CustomButton
                          text={'Update Account'}
                          onPress={props.handleSubmit}
                        />
                      </View>
                    </View>
                  )}
                </View>
              </Card>
            </ScrollView>
          )}
        </Formik>
      </View>
    </KeyboardAvoidingView>
  )
}

export default Editdirectdeposit

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    padding: 16
  }
})
